const unmaskMoney = value =>
    Number(
        value
            .replace(/[a-z]\$\s/gi, '')
            .replace(',', '.')
            .replace(/\.(?=[0-9]{3})/g, ''),
    );

export default unmaskMoney;
